import React from "react";
import assetify from "@quintype/framework/assetify";
import { string, bool } from "prop-types";

import DefaultDesktopLogo from "../../../../assets/images/palo-bangla.svg";
import KishorAloLogo from "../../../../assets/images/kishoralo.svg";
import ProtichintaLogo from "../../../../assets/images/protichinta-icon.png";
import BigganchintaLogo from "../../../../assets/images/biggan-chinta.svg";
import TrustLogo from "../../../../assets/images/trust-logo.svg";
import NagorikLogo from "../../../../assets/images/nagorik.svg";
import NaLogo from "../../../../assets/images/Na_logo.svg";
import BondhushavaLogo from "../../../../assets/images/bondhushava.svg";
import EnLogo from "../../../../assets/images/palo-english.svg";

const DesktopLogo = ({ location, lang, isDesktop }) => {
  const renderLogo = () => {
    if (location === "bn" && lang === "bn") {
      return (
        <img
          width={isDesktop ? "260" : "155"}
          height={isDesktop ? "65" : "37"}
          src={`${assetify(DefaultDesktopLogo)}`}
          alt="প্রথম আলো"
          eager="true"
          loading="eager"
        />
      );
    } else if (lang === "en") {
      return (
        <img
          width={isDesktop ? "192" : "109"}
          height={isDesktop ? "65" : "37"}
          src={`${assetify(EnLogo)}`}
          alt="Prothom Alo English"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "kishoralo") {
      return (
        <img
          width={isDesktop ? "160" : "91"}
          height={isDesktop ? "65" : "37"}
          src={`${assetify(KishorAloLogo)}`}
          alt="কিশোর আলো"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "protichinta") {
      return (
        <img
          width={isDesktop ? "213" : "122"}
          height={isDesktop ? "65" : "37"}
          src={`${assetify(ProtichintaLogo)}`}
          alt="প্রতিচিন্তা"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "bigganchinta") {
      return (
        <img
          width={isDesktop ? "176" : "144"}
          height={isDesktop ? "45" : "37"}
          src={`${assetify(BigganchintaLogo)}`}
          alt="বিজ্ঞানচিন্তা"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "nagorik-sangbad") {
      return (
        <img
          width={isDesktop ? "260" : "214"}
          height={isDesktop ? "65" : "30"}
          src={`${assetify(NagorikLogo)}`}
          alt="নাগরিক সংবাদ"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "trust") {
      return (
        <img
          width={isDesktop ? "228" : "130"}
          height={isDesktop ? "65" : "37"}
          src={`${assetify(TrustLogo)}`}
          alt="প্রথম আলো ট্রাস্ট"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "northamerica") {
      return (
        <img
          width={isDesktop ? "167" : "95"}
          height={isDesktop ? "65" : "37"}
          src={`${assetify(NaLogo)}`}
          alt="উত্তর আমেরিকা"
          eager="true"
          loading="eager"
        />
      );
    } else if (location === "bondhushava") {
      return (
        <img
          width={isDesktop ? "226" : "137"}
          height={isDesktop ? "61" : "37"}
          src={`${assetify(BondhushavaLogo)}`}
          alt="প্রথম আলো বন্ধুসভা"
          eager="true"
          loading="eager"
        />
      );
    }
  };
  return <h2 className="desktop-logo">{renderLogo()}</h2>;
};

DesktopLogo.propTypes = {
  location: string,
  lang: string,
  isDesktop: bool,
};

export default DesktopLogo;
